export const useLocal = (key: string) => {
  const getItem = () => {
    const valueStored = localStorage.getItem(key);
    if (valueStored == null) return null;
    try {
      return JSON.parse(valueStored);
    } catch (err) {
      return null;
    }
  };

  const removeItem = () => {
    try {
      return localStorage.removeItem(key);
    } catch (e) {
      console.error(`Could not clear item ${key}`);
      return null;
    }
  };

  const setItem = (value: unknown) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (err) {
      console.error(`Could not set item ${key} with value ${value}`);
    }
  };

  return {
    getItem,
    removeItem,
    setItem,
  };
};
